






import { Component, Vue } from "vue-property-decorator";
import AlertBox from "@/components/Common/Alerts/AlertBox.vue";

@Component({
  components: { AlertBox }
})
export default class Error404 extends Vue {}
